angular
    .module('webcomm')
    .factory('textMessageService', [
        '$rootScope',
        '$log',
        'wtcpjsClientProviderService',
        'feedModel',
        'channelModel',
        'endpointModel',
        function (
            $rootScope,
            $log,
            wtcpjsClientProviderService,
            feedModel,
            channelModel,
            endpointModel) {
        const patterns = {
            url: /(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?/gmi,
            webSocket: /^ws{1,2}:\/\//i
        };

        var unbindTextMessageHandler;
            var unbindPrivateMessageHandler;
        let service = {};
        let client = wtcpjsClientProviderService.getClient;
        let clientSentFeedIds = [];
        // tracks which dynamic channel ID is associated with which endpoint Id for PrivateCall Text Messages
        let p2pChannelMap = {};

        $rootScope.$on('channelModel.privateCallChannelAdded', function(e, d) {
            if(d.participantId) {
                p2pChannelMap[d.participantId] = d.id;
            }
        });

        $rootScope.$on('channelModel.channelsCleared', () => {
            p2pChannelMap = {};
        });

        $rootScope.$on('privateCallService.callConnected', (e, d) => {
            p2pChannelMap[d.participantId] = d.id;
        });

        $rootScope.$on('wtcpjsService.activeChannelsChanged', function(e, d) {
            setPrivateTxtCapableEndpointProp(endpointModel.getMyEndpoint().id);
        });

        $rootScope.$on('ConnectionService.login', function() {
            setMessageFilters();
        });

        $rootScope.$on('isReconnecting', (e, reconnecting) => {
            if (reconnecting) {
                if(unbindTextMessageHandler) {
                    unbindTextMessageHandler();
                    unbindTextMessageHandler = null;
                }

                if(unbindPrivateMessageHandler) {
                    unbindPrivateMessageHandler();
                    unbindPrivateMessageHandler = null;
                }
            }
        });

        function setMessageFilters() {
            if(unbindTextMessageHandler) {
                unbindTextMessageHandler();
                unbindTextMessageHandler = null;
            }

            if(unbindPrivateMessageHandler) {
                unbindPrivateMessageHandler();
                unbindPrivateMessageHandler = null;
            }

            client().setEndpointPropertiesTextMessageFilter("displayName;callAlias")
                .then((resp) => {
                    unbindTextMessageHandler = subscribeToTextMessageEvent();
                })
                .catch((err) => {
                    $log.error('error setting text message EP Prop filter', err);
                });

            client().setEndpointPropertiesPrivateMessageFilter("displayName;callAlias")
                .then(() => {
                    unbindPrivateMessageHandler = subscribeToPrivateMediaMessageEvent();
                })
                .catch((err) => {
                    $log.error('error setting private message EP Prop filter', err);
                });
        }

        // Workaround until client capabilities work is complete
        function setPrivateTxtCapableEndpointProp(endpointId) {
            client().setEndpointProperties(endpointId, {privateTxtEnabled: true}).then(() => {
                $log.info(`set privateTxtEnabled endpoint property for endpointId ${endpointId}`);
            });
        }

        function lookForUrls(data) {
            /* --- text message parsing rule section for message enrichment --- */
            /* --- should make this more robust and support linkifying urls even in message bodies --- */

            var mIndx = 0, m;

            data.urls = [];

            while ((m = patterns.url.exec(data.message))) {
                data.urls[mIndx++] = { index: m.index, value: m[0] };
            }
        }

        function generateFeedEvent(id, data) {

            lookForUrls(data);
            let newEvent = feedModel.addChannelFeedEvent(id, data.properties.displayName, "text-message", data);
            return newEvent.feedId;
        }

        function subscribeToTextMessageEvent() {
            return client().onTextMessageReceived.subscribe(function(data) {
                $rootScope.$applyAsync(function () {
                    var id = data.destinationChannelId;
                    var myEndpoint = endpointModel.getMyEndpoint();
                    data.sameEndpoint = myEndpoint.id === data.sourceEndpointId;
                    data.Self = myEndpoint.userName === data.sourceUserName;
                    var feedId;

                    if (!data.sameEndpoint) {
                        feedId = generateFeedEvent(id, data);
                    } else {
                        feedId = clientSentFeedIds.shift();
                    }

                    $log.debug("OnTextMessageReceived: ", data);

                    $rootScope.$broadcast('textMessageService.textMessageComplete', feedId);
                });
            });
        }

        function subscribeToPrivateMediaMessageEvent() {
            return client().onPrivateMediaMessageReceived.subscribe(function(data) {
                $rootScope.$applyAsync(function () {
                    var myEndpoint = endpointModel.getMyEndpoint();
                    // This data has changed, will need to revise
                    data.Self = myEndpoint.userName === data.sourceUserName;
                    data.message = data.messageData.data;

                    var destination = data.Self ? data.messageData.participants.find((p) => p.userName !== myEndpoint.userName) : null;

                    var callAlias = data.Self ? destination.callAlias : data.properties.callAlias;
                    var displayName = data.Self ? destination.displayName : data.properties.displayName;
                    var participantId = data.Self ? destination.userName : data.sourceUserName;

                    var id = (p2pChannelMap[data.sourceUserName] || (p2pChannelMap[data.sourceUserName] = (channelModel.addOrUpdatePrivateCallChannel(
                        2,
                        myEndpoint.userName,
                        participantId,
                        callAlias,
                        displayName,
                        null,
                        participantId))));

                    //channelModel.selectChannel(id);

                    var feedId = generateFeedEvent(id, data);

                    $log.debug("OnPrivateMediaMessageReceived: ", data);

                    $rootScope.$broadcast('textMessageService.textMessageComplete', feedId);
                });
            });
        }
        
        function getTxtData(channel, endpoint, message, isAlert) {
            return  {
                Self: true,
                destinationChannelId: channel.id,
                important: isAlert || false,
                message: message,
                name: endpoint.name
            };
        }

        function sendMessage(targetEndpoint, myEndpoint, channel, message, feedId, conversationId, isAlert) {
            var txtData = getTxtData(channel, myEndpoint, message, isAlert);
            var msg = {};

            if (!feedId) {
                lookForUrls(txtData);
                msg = feedModel.addChannelFeedEvent(channel.id, myEndpoint.name, 'text-message', txtData);
                msg.clientTime = 'sending...';
                clientSentFeedIds.push(msg.feedId);
            }

            var p2pMessage = new WtcpJs.PrivateTextMessageRequest({conversationId});
            p2pMessage.data = message;
            p2pMessage.participants.push(targetEndpoint.userName);
            p2pMessage.participants.push(myEndpoint.userName);
            p2pMessage.Label = `Conversation with ${myEndpoint.name}`;

            return client().sendP2PMessage(p2pMessage, {important: txtData.important})
                .then((resp) => {
                    if (resp.errorCode === 0) {
                        msg.confirmed = true;
                        msg.clientTime = resp.textMsgConfirmedDate;
                        return msg.feedId;
                    } else {
                        throw new Error(resp.errorMessage);
                    }
                })
                .catch((err) => {
                    $log.error("there was an error sending private text message", err);
                    throw {feedId: msg.feedId, errorMessage: err.errorMessage};
                });
        }

        service.sendPrivateTextMessage = function ( channel, targetEndpoint, myEndpoint, message, feedId, isAlert) {

            return sendMessage(targetEndpoint, myEndpoint, channel, message, feedId, null, isAlert);
        };

        service.sendTextMessage = function (channel, endpoint, message, feedId, isAlert) {
            if (!endpoint) {
                return false;
            }

            let txtData = getTxtData(channel, endpoint, message, isAlert);

            let msg = {};

            if (!feedId) {
                lookForUrls(txtData);
                msg = feedModel.addChannelFeedEvent(channel.id, endpoint.name, 'text-message', txtData);
                msg.clientTime = 'sending...';
            }

            return client().sendTextMessage(channel.id, message, {important: txtData.important})
                .then((resp) => {
                    if (resp.errorCode === 0) {
                        msg.confirmed = true;
                        msg.clientTime = resp.textMsgConfirmedDate;
                        clientSentFeedIds.push(msg.feedId);
                        return msg.feedId;
                    } else {
                        throw new Error(resp.errorMessage);
                    }
                })
                .catch((err) => {
                    throw {feedId: msg.feedId, errorMessage: err.errorMessage};
                });
        }

        /* --- Initializations --- */

        setMessageFilters();

        // TBD: Remove once private messaging is working
        //setPrivateTxtCapableEndpointProp(endpointModel.getMyEndpoint().id);

        $log.debug('textMessageService initialized');
        return service;
    }]);